import { useState } from "react";
import ReactModal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { zvForm } from "../Tabellen/ConstTabKopf/ZweckverbandKopf";

import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require("monitor-api");

export default function ZvCreate({ instance, reloadData }) {
    const [newZv, setNewZv] = useState(new MonitorApi.ZweckverbandCreateCommand());

    const [showModal, setShowModal] = useState(false);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewZv(new MonitorApi.ZweckverbandCreateCommand());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }


    const changingInput = event => {
        event.preventDefault();
        // console.log(event.target.name, event.target.value)
        setNewZv(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        let creating = new Promise((resolve) => {
            instance.createZweckverbandZweckverbandPost(newZv, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Neuer Zweckverband ${data.zweckverband} erstellt unter der Id: ${data.id}`);
                    resolve(data);
                }
            })
        })
        creating.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neuer Zweckverband</MyNewButton>
            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neuer Zweckverband:</h3>
                    {zvForm.map((column, index) => {
                        return (
                            <MyModalContentRow key={index}>
                                {<label>{`${column.Header}: `}
                                    <MyModalContentTextInput name={column.accessor} onChange={changingInput} required={column.required} />
                                </label>}
                            </MyModalContentRow>
                        )
                    })}
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}